import { render, staticRenderFns } from "./PackDetail.vue?vue&type=template&id=7be0a58a&scoped=true&"
import script from "./PackDetail.vue?vue&type=script&lang=js&"
export * from "./PackDetail.vue?vue&type=script&lang=js&"
import style0 from "./PackDetail.vue?vue&type=style&index=0&id=7be0a58a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be0a58a",
  null
  
)

export default component.exports